import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { LocationPartnerRoutingModule } from "./location-partner-routing.module";
import { MainComponent } from "./main/main.component";
import { PromoteComponent } from "./promote/promote.component";
import { RemunerationComponent } from "./remuneration/remuneration.component";
import { SharedModule } from "src/app/shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LatestAdComponent } from './main/latest-ad/latest-ad.component';
import { CarouselModule } from "ngx-owl-carousel-o";
import { OwlDateTimeModule } from "@danielmoncada/angular-datetime-picker";
import { CaseFsiComponent } from './remuneration/case-fsi/case-fsi.component';
import { NgxAbstractControlAsModule } from "ngx-abstract-control-as";

@NgModule({
  declarations: [
    MainComponent,
    PromoteComponent,
    RemunerationComponent,
    LatestAdComponent,
    CaseFsiComponent,
  ],
  imports: [
    CommonModule,
    LocationPartnerRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CarouselModule,
    OwlDateTimeModule,
    NgxAbstractControlAsModule
  ],
  exports:[PromoteComponent]
})
export class LocationPartnerModule {}
